export const OTHER_OUTCOME_DESCRIPTION = 'Other';
